// extracted by mini-css-extract-plugin
export var cardContainer = "_nf-0";
export var cardHeader = "_nf-2";
export var collapsedState = "_nf-3";
export var dragHandle = "_nf-5";
export var dragHandleIcon = "_nf-6";
export var dragging = "_nf-1";
export var titleArea = "_nf-4";